import HttpRequest from './HttpRequest'

const httpAgent: any = new HttpRequest()

export default httpAgent
